"use client";
import {
  Box,
  CircularProgress,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import { UploadIcon } from "@/icons";
import { memo, useMemo } from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

const AppUploadFile = ({
  title = "Tải lên tập tin của bạn",
  description = "Tải lên ảnh (hỗ trợ các định dạng đuôi JPG, PNG, JPEG)",
  file,
  url,
  sx,
  rootProp,
  inputProp,
  isFetching,
}: IAppUpLoadFile) => {
  const imageUrl = useMemo(
    () => (file ? URL.createObjectURL(file) : ""),
    [file]
  );
  return (
    <Stack
      sx={{
        border: "1.5px dashed #2AAB4A",
        minHeight: "120px",
        maxHeight: "300px",
        borderRadius: "6px",
        backgroundColor: "rgba(42, 171, 74, 0.10)",
        opacity: "0.8",
        padding: "0 8px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        overflow: "hidden",
        ":hover": { cursor: "pointer" },
        ...sx,
      }}
      {...rootProp}
    >
      <input {...inputProp} />
      {file || url ? (
        <Box
          sx={{ objectFit: "cover", maxWidth: "100%", maxHeight: "300px" }}
          component="img"
          src={imageUrl || url}
        />
      ) : isFetching ? (
        <CircularProgress color="success" />
      ) : (
        <>
          <UploadIcon
            sx={{ width: "40px", height: "38px", cursor: "pointer" }}
          />
          <Typography
            textAlign="center"
            variant="h4"
            fontWeight="700"
            sx={{ cursor: "default" }}
          >
            {title}
          </Typography>
          <Typography
            variant="h5"
            color="#999"
            textAlign="center"
            sx={{ cursor: "default" }}
          >
            {description}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export default memo(AppUploadFile);

type IAppUpLoadFile = {
  sx?: SxProps;
  title?: string;
  description?: string;
  file?: File;
  url?: string;
  isFetching?: boolean;
  rootProp: DropzoneRootProps;
  inputProp: DropzoneInputProps;
};
